/* C3-R3A local successor: no analytics, cart, checkout, or commerce handlers. */
(() => {
  document.documentElement.classList.add('eb-c3-js-ready');
})();
